import { FrontlineDocumentService } from './../../../../core/services/frontline-document.service';
import { UploadMutlipleFileRequest } from './interface/upload-mutliple-file-request';
import { Component, Input, OnInit, Injector, ViewChild } from '@angular/core';
import { ShippingDocumentService } from 'src/app/core/services/shipping-document.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { SearchDocumentsRequest } from './interface/search-documents-request';
import { FileCategory } from 'src/app/core/constants/file-category.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CodeConverter } from 'server/entity/code-converter';
import { LaasOption } from 'src/app/core/models/laas-option';
import { isNullOrEmpty, deepCopy } from 'src/app/core/utils/common-functions';
import { DownloadMergeFileRequset } from 'src/app/core/models/transport-operation/download-merge-file-request';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FileUpload } from 'primeng/fileupload';
import { UploadFileBean } from './interface/upload-file-bean';
import { TaskDocResetLockRequest } from '../frontline-document/interface/front-line-doc-reset-lock-request';
import * as JSZip from 'jszip';
import * as e from 'express';

@Component({
  selector: 'laas-file-management',
  templateUrl: './file-management.component.html',
  styleUrls: ['./file-management.component.scss']
})
export class FileManagementComponent extends SessionBaseComponent implements OnInit {
  @Input() referenceKeys!: string[];
  @Input() fileCategory!: FileCategory;
  @Input() limitDocTypes: any[] = [];
  @Input() isDownloadMode: boolean = false;
  @Input() customDocTypeOptions: LaasOption[] = [];
  @Input() uploadFileType!: string;
  @Input() headerString: string = '';
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  readonly doNeedCheckDocType: string[] = ["COC", "DeliveryNoteLK", "Invoice", "InvoiceAJB", "PackingList", "PackingListAJB", "ProformaInvoice"];

  switchDisable: boolean;
  switchMergeDisable: boolean;
  isMultiple: boolean;
  isMergeFile: boolean;
  isLoading: boolean;
  isFileUploadLoading: boolean;
  docReference: string;
  docTypeOptions: LaasOption[] = [];
  cloneDocTypeOptions: LaasOption[] | null = [];
  documents: any[] = [];
  selectedDocType: string;
  needCheckReferenceKeys: string[] = [];
  uploadFileBeans: UploadFileBean[];

  constructor(injector: Injector,
      private shippingDocumentService: ShippingDocumentService,
      private commonDataService: CommonDataService,
      private DOService: DeliveryOrderService,
      private frontlineDocumentService: FrontlineDocumentService
      ) {

    super(injector);
    this.switchDisable = false;
    this.switchMergeDisable = false;
    this.isLoading = false;
    this.isFileUploadLoading = false
    this.isMultiple = false;
    this.isMergeFile = false;
    this.docReference = "";
    this.selectedDocType = "";
    this.uploadFileBeans = [];
   }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  searchDocumentsByDocTypes(): void {
    this.needCheckReferenceKeys = [];

    this.isLoading = true;
    const docTypes = (this.cloneDocTypeOptions || [])
    .map((e) => String(e.value));

    const searchObj = this.generateSearchDocRequest(this.referenceKeys, docTypes);

    this.shippingDocumentService.getDocs(searchObj).subscribe({
      next: (result) => {
        console.log(result);
        this.documents = result.body;
      },
      complete: () => {
        this.isLoading = false;
        console.log(this.documents);
      },
    });
  }

  searchDocuments(docType: string): void {
    this.needCheckReferenceKeys = [];

    this.isLoading = true;
    var docTypes = [docType];

    const searchObj = this.generateSearchDocRequest(this.referenceKeys, docTypes);

    this.shippingDocumentService.getDocs(searchObj).subscribe({
      next: (result) => {
        console.log(result);
        this.documents = result.body;

        // 如果是需要判斷其他平台有沒有檔案的文件類型，則要先比對keys (目前只有出貨會用到)
        if (this.doNeedCheckDocType.includes(docType) && this.docReference == "DeliveryOrder") {

          if (isNullOrEmpty(result.body)) {
            this.needCheckReferenceKeys = this.needCheckReferenceKeys.concat(this.referenceKeys);
          } else {
            const keys = this.documents.map(doc => {return doc.referenceKey});
            this.compareReferenceKeyNotInDB(this.referenceKeys, keys);
          }

          for (const key of this.needCheckReferenceKeys) {
            const needRefresnObj = {
              referenceKey: key,
              docType: docType,
              isNeedRefresh: true
            }

            this.documents.push(needRefresnObj);
          }

        }

      },
      complete: () => {
        this.isLoading = false;
        console.log(this.documents);
      },
    });
  }

  generateSearchDocRequest(referenKeys: string[], docTypes: string[]): SearchDocumentsRequest {
    let searchDocumentsRequest = new SearchDocumentsRequest();
    for (const key of referenKeys) {
      searchDocumentsRequest.docReference.push(
        {
          key: key,
          name: this.docReference
        }
      )
    }
    searchDocumentsRequest.docType = docTypes;
    return searchDocumentsRequest;
  }

  onDocTypeChange(event: any) {
    if (!isNullOrEmpty(event.value)) {
      return this.searchDocuments(event.value);
    }
    return this.searchDocumentsByDocTypes();
  }

  compareReferenceKeyNotInDB(referenceKeys: string[], referenceKeysInDB: string[]) {
    for (const key of referenceKeys) {
      if (!referenceKeysInDB.includes(key)) {
        this.needCheckReferenceKeys.push(key);
      }
    }
  }

  resetComponent(): void {

    this.selectedDocType = "";
    this.documents = [];
    this.needCheckReferenceKeys = [];
    this.uploadFileBeans = [];
    this.isMultiple = false;
    this.isMergeFile = false;
    this.switchDisable = false;
    this.switchMergeDisable = false;
    if (this.fileUpload) {
      this.fileUpload.files = [];
    }

    this.docReference = this.fileCategory.docReference;

    if(this.fileCategory == FileCategory.DeliveryOrder){
      this.docTypeOptions = this.customDocTypeOptions;
    }else{
      this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", this.fileCategory.codeConverterType).subscribe({
        next: (results: CodeConverter[]) => {
          this.translateService.get('Common.DropDown.Select').subscribe({
            next: (str) => {
              this.cloneDocTypeOptions = results.map(x => {
                return {
                  label: x.codeDesc,
                  value: x.codeKey
                } as LaasOption
              });

              if (this.cloneDocTypeOptions != null) {
                if (this.limitDocTypes.length > 0) {
                  this.docTypeOptions = this.cloneDocTypeOptions.filter(docType =>{
                    return this.limitDocTypes.includes(docType.value);
                  });
                } else {
                    this.docTypeOptions = this.cloneDocTypeOptions;
                }
                this.docTypeOptions.unshift({
                  label: str,
                  value: '',
                });
                this.searchDocumentsByDocTypes();
              }
            },
          });
        }
      });
    }

  }

  downloadChange(event: Event, rowData: any) {
    const searchObj = {
      sn: rowData.docId,
      version: rowData.version,
    };

    if (rowData.docType == 'ProofOfDelivery' || 'AWB') {
      let downloadMergeFileParams = new DownloadMergeFileRequset();

      downloadMergeFileParams.docReference = null;
      downloadMergeFileParams.remarks = null;
      downloadMergeFileParams.docTypes = rowData.docType.split(',');
      downloadMergeFileParams.referenceKeys = rowData.referenceKey.split(',');
      console.log(downloadMergeFileParams);
      this.shippingDocumentService.downloadMergeFile(downloadMergeFileParams).subscribe({
        next: (downloadMergeFileResponse) => {

          // 判斷isMutipleFile的值是MULTIPLE還是SINGLE決定是否壓縮成zip
          if (downloadMergeFileResponse.isMutipleFile == 'MULTIPLE') {
            const byteStr = atob(downloadMergeFileResponse.file);
            const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
            const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteStr.length; i++) {
              int8Array[i] = byteStr.charCodeAt(i);
            }

            const data: Blob = new Blob([int8Array], { type: 'application/zip' });
            const url = URL.createObjectURL(data);
            const linkEle = document.createElement('a');
            linkEle.href = url;
            linkEle.download = downloadMergeFileResponse.fileName;
            linkEle.click();
            URL.revokeObjectURL(url);
            linkEle.remove();
            this.loader.hide();
            } else {
              const byteStr = atob(downloadMergeFileResponse.file);
              const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
              const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

              for (let i = 0; i < byteStr.length; i++) {
                int8Array[i] = byteStr.charCodeAt(i);
              }

              const blob = new Blob([int8Array], { type: 'application/octet-stream' }); // application後面接下載的副檔名
              let url = window.URL.createObjectURL(blob);
              let linkEle = document.createElement('a');
              linkEle.href = url;
              linkEle.download = `${rowData.docType}_${rowData.referenceKey}.${rowData.fileType}`; // 瀏覽器下載時的檔案名稱
              linkEle.click();
          }

        }
      });
    } else {
      this.DOService.downloadFile(searchObj).subscribe((x) => {
        const blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

        let downloadURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        link.download = `${rowData.docType}_${rowData.referenceKey}.${rowData.fileType}`; // 瀏覽器下載時的檔案名稱
        link.click();
      });
    }
  }

  attachFile(event: Event, rowData: any) {
    this.isLoading = true;
    this.shippingDocumentService.downloadDocuments(rowData.docType, this.docReference, [rowData.referenceKey], this.userProfile.userName, false, rowData.referenceKey)
    .subscribe({next: (results: any[]) => {
      if (results.length === 0 ||
        results[0].attachFileDetailBeans.length === 0 ||
        isNullOrEmpty(results[0].attachFileDetailBeans[0].file) ||
        isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName)) {
        //無檔案可下載
        this.translateService.get('BoookingSearch.Info.NoFileDownload')
          .subscribe({
            next: result => {
              this.toastService.info(result);
            }
          });
        return;
      }
      const fileInfo = results[0].attachFileDetailBeans[0];
      const byteStr = atob(fileInfo.file);
      const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
      const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteStr.length; i++) {
        int8Array[i] = byteStr.charCodeAt(i);
      }
      const data: Blob = new Blob(
        [int8Array]
      );
      const url = URL.createObjectURL(data);
      const linkEle = document.createElement('a');
      linkEle.href = url;
      linkEle.download = fileInfo.fileName;
      linkEle.click();
      URL.revokeObjectURL(url);
      linkEle.remove();
    },
    error: (err: HttpErrorResponse) => {
      this.toastErrorMessage(err);
    },
    complete: () => {
      this.isLoading = false;
    }
  });

  }

  async fileUploader(event: any): Promise<void> {


    this.isFileUploadLoading = true;

    if (this.isMultiple && event.files.length >= 1) {
      if (!this.checkReferenceKeyLogic()) {
        this.isFileUploadLoading = false;
        return;
      }
      let uploadFileReq = new UploadMutlipleFileRequest();
      for (let i = 0; i < event.files.length; i++) {
        const file = event.files[i];
        this.uploadFileBeans[i].fileBase64 = await this.readAsDataURL(file);
      }
      uploadFileReq.docReference = this.docReference;
      uploadFileReq.docType = this.selectedDocType;
      uploadFileReq.referenceKeys = this.referenceKeys;
      uploadFileReq.userId = this.userProfile.userName;
      uploadFileReq.fileBeans = deepCopy(this.uploadFileBeans);
      console.log(uploadFileReq);

      this.shippingDocumentService.uploadMutlipleDocuments(uploadFileReq).subscribe({
        next: result => {
          console.log(result);
          this.toastService.success("Upload Success");
          this.fileUpload.clear();
          this.searchDocuments(this.selectedDocType);
        },
        error: err => {
          this.isFileUploadLoading = false;
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isFileUploadLoading = false;
        }
      });
    } else {

      // 單一DO上傳多個檔案合併成一個zip
      if(this.isMergeFile && event.files.length > 1){
        const zip = new JSZip();
        this.confirmationService.confirm({
          message: this.translateService.instant('FileUpload.MergeFile.Info'),
          header: this.translateService.instant('FileUpload.MergeFile.Header'),
          icon: 'pi pi-info-circle',
          accept: async () => {
            this.loader.show();
            for (const file of event.files) {
              zip.file(file.name, file);
            }
            try {
              var fileBlob = await zip.generateAsync({ type: 'blob' });
              var filename = this.referenceKeys + "_" + this.selectedDocType;
              var fileType = 'zip';
              let fileBase64 = await this.readAsDataURL(fileBlob);

              let uploadReq = {
                docReference: this.docReference,
                docType: this.selectedDocType,
                fileName: filename,
                fileType: fileType,
                referenceKey: this.referenceKeys,
                uploadFile: fileBase64,
                userId: this.userProfile.userName,
                remark: this.docReference,
              };
              this.uploadDocuments(uploadReq);
              this.isFileUploadLoading = false;


            } catch (error) {
              console.error('Error generating ZIP Blob:', error);
              this.isFileUploadLoading = false;

              this.toastService.info(
                this.translateService.instant('FileUpload.MergeFile.ErrorInfo')
              );
            }
          },
          reject: (type: any) => {
            this.isFileUploadLoading = false;
            this.toastService.info(
              this.translateService.instant('FileUpload.MergeFile.cancelInfo')
            );
          },
        });

      }else{

        var file = event.files[0];
        console.log(file);

        var regexAll = /[^\\]*\.(\w+)$/;
        var total = file.name.match(regexAll);
        var filename = total[0].split('.')[0];
        var fileType = total[1];

        if(!isNullOrEmpty(this.uploadFileType) && fileType != this.uploadFileType){
          console.log(this.uploadFileType);
          this.toastService.warn(this.translateService.instant('FileUpload.OnlyUploadPdf'));
          this.isFileUploadLoading = false;
          return;
        }

        let fileBase64 = await this.readAsDataURL(file);

        let uploadReq = {
          docReference: this.docReference,
          docType: this.selectedDocType,
          fileName: filename,
          fileType: fileType,
          referenceKey: this.referenceKeys,
          uploadFile: fileBase64,
          userId: this.userProfile.userName,
          remark: this.docReference
        };
        console.log(uploadReq);
        this.uploadDocuments(uploadReq);
      }

    }
  }

  private uploadDocuments(uploadReq: { docReference: string; docType: string; fileName: string; fileType: string; referenceKey: string[]; uploadFile: string | ArrayBuffer | null; userId: any; remark: string; }) {
    this.shippingDocumentService.uploadDocuments(uploadReq)
      .subscribe({
        next: (result) => {
          console.log(result);
          this.toastService.success('Upload Success');
          this.fileUpload.clear();
          this.isFileUploadLoading = false;
          this.searchDocuments(this.selectedDocType);
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
          this.isFileUploadLoading = false;
        },
        complete: () => {
          this.isFileUploadLoading = false;
        },
      });
  }

  async readAsDataURL(file: any): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve) => {
      let fileReader = new FileReader();
      fileReader.onload = function () {
        return resolve((fileReader.result as string)?.split(',')[1]);
      }
      fileReader.readAsDataURL(file);
    })
  }

  async onSelectedFiles(event: any) {
    this.switchDisable = true;

    if (this.isMultiple) {
      for (const file of event.files) {
        let fileBean = new UploadFileBean();
        var regexAll = /[^\\]*\.(\w+)$/;
        let total = file.name.match(regexAll);
        console.log(total);
        fileBean.fileName = total[0].split('.')[0];
        fileBean.fileType = total[1];
        for (const referenceKey of this.referenceKeys) {
          if (fileBean.fileName.includes(referenceKey)) {
            fileBean.referenceKey = referenceKey;
          }
        }
        this.uploadFileBeans.push(fileBean);
      }
      console.log(this.uploadFileBeans)
    }

    const fileCount = this.fileUpload.files.length;
    console.log("onSelectedFiles fileCount = " + fileCount);
    if (fileCount > 1) {
      this.switchMergeDisable = true;
    }else{
      this.switchMergeDisable = false;
    }

  }

  onClearFiles(event: any) {
    if (this.referenceKeys.length > 1) {
      this.switchDisable = false;
      this.uploadFileBeans = [];
    }
    this.switchMergeDisable = false;
  }

  onRemoveFiles(event: any) {
    this.uploadFileBeans = this.uploadFileBeans.filter(fileBean => fileBean.fileName + '.' + fileBean.fileType != event.file.name)

    if (this.uploadFileBeans.length == 0) {
      this.switchDisable = false;
    }
    const fileCount = this.fileUpload.files.length;
    console.log("onRemoveFiles fileCount = " + fileCount);
    if (fileCount > 2) {
      this.switchMergeDisable = true;
    }else{
      this.switchMergeDisable = false;
    }
  }

  onSelectReferenceKey(event: any, file: any) {
    this.uploadFileBeans[this.fileUpload._files.indexOf(file)].referenceKey = event.value;
  }

  canDeleteFile(rowData: any): boolean {
    if (!rowData.updateUser) return false;
    const isUploader = rowData.updateUser == this.userProfile.userName || rowData.updateUser == this.userProfile.loginAccount;
    const isSystemFile = rowData.updateUser.toUpperCase() == 'SYSTEM' && this.fileCategory.canDeleteSystemFile;

    return isUploader || isSystemFile;
  }

  deleteFileBtnClick(event: any, deleteObj: any): void {
    this.confirmationService.confirm({
      target: event.target,
      message: this.translateService.instant('FileUpload.DeleteMsg'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteFile(event, deleteObj);
        if (this.fileCategory == FileCategory.FrontLine || this.fileCategory == FileCategory.CustomerLabel) {
          console.log(deleteObj.referenceKey)
          console.log(deleteObj.docType)

          this.doResetLock(deleteObj.referenceKey, deleteObj.docType, this.userProfile.userName, this.fileCategory.taskClassName, this.fileCategory.doLockHeader);
        }
      },
      reject: () => {
        //reject action
      },
    });
  }

  deleteFile(event: any, deleteObj: any): void {
    // if (deleteObj.docType == "ProofOfDelivery") {
    if (deleteObj.docId) {
      this.shippingDocumentService.deleteFileBySnCode(deleteObj.docId).subscribe({
        next: (result) => {
          this.toastService.success(
            this.translateService.instant('BoookingSearch.Success.DeleteSuccess'),
            false
          );
          this.searchDocuments(this.selectedDocType);
        },
        error: (result) => {
          this.toastService.error(
            this.translateService.instant('BoookingSearch.Error.DeleteFail')
          );
        },
      });
    } else {
      this.shippingDocumentService.deleteFile(deleteObj.seqNo).subscribe({
        next: (result) => {
          this.toastService.success(
            this.translateService.instant('BoookingSearch.Success.DeleteSuccess'),
            false
          );
          this.searchDocuments(this.selectedDocType);
        },
        error: (result) => {
          this.toastService.error(
            this.translateService.instant('BoookingSearch.Error.DeleteFail')
          );
        },
      });
    }
  }

  checkReferenceKeyLogic(): boolean {
    const keyList = this.uploadFileBeans.map(fileBean => fileBean.referenceKey);

    // 明明只有兩個號碼但是他選很多檔案
    if (this.uploadFileBeans.length > this.referenceKeys.length) {
      this.toastService.warn(this.translateService.instant('FileUpload.OneFileWarn'));
      return false;
    }

    // 如果有人沒選號碼
    if (keyList.indexOf("") != -1) {
      this.toastService.warn(this.translateService.instant('FileUpload.ChooseFileWarn'));
      return false;
    }

    // 如果號碼distinct完結果跟檔案的數量不一樣，代表有人兩個檔案放一樣的號碼
    if (Array.from(new Set(keyList)).length < this.uploadFileBeans.length) {
      this.toastService.warn(this.translateService.instant('FileUpload.OneFileWarn'));
      return false;
    } else {
      return true;
    }

  }

  downloadPdf(event: Event): void{
    this.loader.show();

    console.log("doNos: " + this.referenceKeys);

    const downloadPdfParams = {
      docReference: this.docReference,
      referenceKeys: this.referenceKeys,
      docType: this.selectedDocType
    };

    this.shippingDocumentService.downloadPdf(downloadPdfParams).subscribe(
      {
        next: x => {
          const byteStr = atob(x.file);
          const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
          const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteStr.length; i++) {
            int8Array[i] = byteStr.charCodeAt(i);
          }
          const data: Blob = new Blob(
            [int8Array], { type: 'application/pdf' }
          );
          const url = URL.createObjectURL(data);
          const linkEle = document.createElement('a');
          linkEle.href = url;
          linkEle.download = `${this.selectedDocType}.pdf`;
          linkEle.click();
          URL.revokeObjectURL(url);
          linkEle.remove();

          this.loader.hide();
        },
        error: err => {
          this.toastErrorMessage(err.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        }
      }
    )
  }

  downloadZip(event: Event): void{
    this.loader.show();

    console.log("doNos: " + this.referenceKeys);

    const downloadZipParams = {
      docReference: this.docReference,
      referenceKeys: this.referenceKeys,
      docType: this.selectedDocType
    };

    this.shippingDocumentService.downloadZip(downloadZipParams)
    .subscribe(
      {
        next: x => {
          const byteStr = atob(x.file);
          const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
          const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteStr.length; i++) {
            int8Array[i] = byteStr.charCodeAt(i);
          }
          const data: Blob = new Blob(
            [int8Array], { type: 'application/zip' }
          );
          const url = URL.createObjectURL(data);
          const linkEle = document.createElement('a');
          linkEle.href = url;
          linkEle.download = `${this.selectedDocType}.zip`;
          linkEle.click();
          URL.revokeObjectURL(url);
          linkEle.remove();

          this.loader.hide();
        },
        error: err => {
          this.toastErrorMessage(err.error);
          this.loader.hide();
        },
        complete: () => {
          this.loader.hide();
        }
      }
    )
  }

  async doResetLock(doNo: string, docType: string, user: string, taskClassName: string, doLockHeader: string | null) {
    let request = new TaskDocResetLockRequest();
    request.doNo = doNo;
    request.docType = docType;
    request.user = user;
    request.taskClassName = taskClassName;
    request.doLockHeader = doLockHeader;

    console.log(request);

    await this.frontlineDocumentService.resetDoLockStatus(request).toPromise();
  }

}
